import CryptoJS from 'crypto-js'

interface CryptoConfig {
  enable: boolean
  key: string
  iv: string
}

let _config: CryptoConfig | null = null

export function setCryptoConfig(cfg: CryptoConfig) {
  _config = cfg
}

export function isEncryptEnabled(): boolean {
  return !!(_config?.enable && _config.key?.length === 16 && _config.iv?.length === 16)
}

export async function aesEncrypt(plaintext: string): Promise<string> {
  if (!_config) throw new Error('Crypto config not initialized')
  const key = CryptoJS.enc.Utf8.parse(_config.key)
  const iv = CryptoJS.enc.Utf8.parse(_config.iv)
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return encrypted.toString()
}

export async function aesDecrypt(ciphertext: string): Promise<string> {
  if (!_config) throw new Error('Crypto config not initialized')
  const key = CryptoJS.enc.Utf8.parse(_config.key)
  const iv = CryptoJS.enc.Utf8.parse(_config.iv)
  const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
